import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import {
  getDoc,
  doc,
  getDocs,
  collection,
  query,
  where,
  onSnapshot,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import ProfilePicture from "./ProfilePicture";
import useModalStore from "../StatesStore/ModalStore";
import useNotification from "../hooks/useNotification";
import UpdatePFP from "./UpdatePFP";
import useFeedNotification from "../hooks/useFeedNotification";
import ChatToast from "../Chat/ChatToast";
import useSocketStore from "../StatesStore/Socket";
import { Button, Form, Modal } from "react-bootstrap";
import useFollowUser from "../hooks/useFollowUser";
import { HandleUnfriend } from "./ActiveConnections";
import {
  HandleAcceptConnectionReq,
  HandleRejectConnectionReq,
} from "./ConnectionRequest";
import SendFriendRequest from "./SendConnectionRequest";
import handlefollowUser from "../hooks/user/followUser";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import UserProfileChatMobile from "../Chat/UserProfileChatMobile";
import FollowerFollowingSidebar from "./FollowerFollowingSidebar";
import CheckFollow from "./CheckFollow";
import { listNameExists } from "../lib/listNameExists";
import axios from "axios";
import uuid4 from "uuid4";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import useChatClient from "../StatesStore/ChatClient";
import BottomTray from "../Trays/BottomTray";
import CreateNewList from "../Trays/CreateNewList";

const UserProfileHeader5 = ({ selectedOption, setSelectedOption }) => {
  const { uid } = useParams(); // Extract the "uid" parameter from the URL
  const [userData, setUserData] = useState(null);
  const { user } = UserAuth();
  const [show, setShow] = useState(false);
  const [showNewListModal, setShowNewListModal] = useState(false);
  const socket = useSocketStore((state) => state.socket);
  const [friendUid, setfriendUid] = useState(uid);
  const [activeList, setActiveList] = useState([]);
  const [pendinglist, setPendingList] = useState([]);
  const [requestlist, setRequestList] = useState([]);
  const [followerCount, setFollowerCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);
  const [newListName, setNewListName] = useState("");
  const [error, setError] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { openModal } = useModalStore();
  const navigate = useNavigate();
  const { addNotification, deleteNotification } = useNotification();
  const { addFeedNotification } = useFeedNotification();
  // State to track if profile picture is updated
  const [profilePictureUpdated, setProfilePictureUpdated] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [followers, setFollowers] = useState([]);
  const [followings, setFollowings] = useState([]);
  const { client } = useChatClient();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleClose = () => setShow(false);
  const handleCloseNewModal = () => setShowNewListModal(false);
  const handleCancel = async () => {
    await HandleRejectConnectionReq(friendUid, user?.uid);
    setPendingList(pendinglist.filter((id) => id !== uid));
    handleClose();
    toast.success("Request removed successfully!", toastOptions);
  };
  const handleAccept = async () => {
    await HandleAcceptConnectionReq(friendUid, user?.uid);
    setPendingList(pendinglist.filter((id) => id !== uid));
    setActiveList([...activeList, uid]);
    handleClose();
    toast.success("Request accepted successfully!", toastOptions);
  };

  const handleChatClick = (e) => {
    e.preventDefault();
    // setIsChatOpen(true);
    // navigate(`/UserProfileChatMobile/${user?.uid}/${uid}`);
    navigate(`/chat`);
  };
  const handleDesktopChatClick = (e) => {
    e.preventDefault();
    setIsChatOpen(true);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };
  // console.log("userData from profile", userData);

  useEffect(() => {
    let unsubscribeFollowers = () => {};
    let unsubscribeFollowing = () => {};
    let unsubscribeUserDoc = () => {};

    const fetchUserData = async () => {
      try {
        if (uid) {
          try {
            const userDocRef = doc(db, "users", uid); // Fetch user data
            unsubscribeUserDoc = onSnapshot(userDocRef, (userDocSnapshot) => {
              if (userDocSnapshot.exists()) {
                setUserData({
                  uid: userDocSnapshot.id,
                  ...userDocSnapshot.data(),
                });

                setFollowerCount(userDocSnapshot.data()?.followerCount || 0);
                setFollowingCount(userDocSnapshot.data()?.followingCount || 0);
              } else {
                console.log("User document does not exist.");
              }
            });

            // if (user) {
            //   // Fetch connections for the user
            //   const connectionsRef = collection(
            //     db,
            //     "users",
            //     user?.uid,
            //     "connections"
            //   );
            //   const connectionsSnapshot = await getDocs(connectionsRef);

            //   // Filter connections by type
            //   const activeConnections = [];
            //   const pendingRequests = [];
            //   const requestList = [];

            //   connectionsSnapshot.forEach((doc) => {
            //     const connectionData = doc.data();
            //     if (connectionData.type === "active") {
            //       activeConnections.push(doc.id);
            //     } else if (connectionData.type === "pending") {
            //       pendingRequests.push(doc.id);
            //     } else if (connectionData.type === "request") {
            //       requestList.push(doc.id);
            //     }
            //   });

            //   setActiveList(activeConnections);
            //   setPendingList(pendingRequests);
            //   setRequestList(requestList);
            // }

            // Set up real-time listener for followers
            const followerRef = collection(userDocRef, "followers");
            const q = query(followerRef);

            unsubscribeFollowers = onSnapshot(q, async (followerSnapshot) => {
              // Get user/brand data for each follower
              const followersData = await Promise.all(
                followerSnapshot.docs.map(async (user) => {
                  const followerCollection =
                    user.data().type === "brand" ? "brands" : "users";
                  const type = user.data().type;
                  const userRef = doc(db, followerCollection, user.id);
                  const userSnap = await getDoc(userRef);
                  return {
                    uid: user.id,
                    ...userSnap.data(),
                    type,
                  };
                })
              );

              setFollowers(followersData);
            });

            // Set up real-time listener for following
            const followingRef = collection(userDocRef, "following");
            const q2 = query(followingRef);

            unsubscribeFollowing = onSnapshot(q2, async (followingSnapshot) => {
              // Get user/brand data for each following
              const followingsData = await Promise.all(
                followingSnapshot.docs.map(async (user) => {
                  const followingCollection =
                    user.data().type === "brand" ? "brands" : "users";
                  const type = user.data().type;
                  const userRef = doc(db, followingCollection, user.id);
                  const userSnap = await getDoc(userRef);
                  return {
                    uid: user.id,
                    ...userSnap.data(),
                    type,
                  };
                })
              );

              setFollowings(followingsData);
            });
          } catch (error) {
            console.error(error);
          }
        } else {
          console.log("No uid provided in the URL.");
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
      }
    };

    fetchUserData();

    // Clean up listeners when component unmounts or dependencies change
    return () => {
      unsubscribeFollowers();
      unsubscribeFollowing();
    };
  }, [user, uid, profilePictureUpdated]);

  //to get screen widths adjusted in avatar
  console.log("pendinglist", pendinglist);

  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.toDate) {
      return "N/A";
    }

    const options = { year: "numeric", month: "short", day: "numeric" };
    return timestamp.toDate().toLocaleDateString("en-US", options);
  };

  const isCurrentUserProfile = user?.uid === uid;

  // console.log('Request list fetched in userprofile header',pendinglist);
  // console.log('loggedinUser document from userprofileheader',loggedinUserDoc);
  // console.log('UserData inside userprofileheader',userData);
  //a

  const handleClick = () => {
    if (!user) {
      openModal("SignInModal", "", "");
    } else if (!user?.emailVerified) {
      openModal("VerifyEmailModal", "", {
        userName: user?.displayName,
        email: user?.email,
      });
    }
  };
  const handleProfilePictureUpdate = () => {
    // Toggle the state to trigger re-render
    setProfilePictureUpdated(!profilePictureUpdated);
  };
  const userProfilePicture = () => {
    return (
      <div
        className="avatar userImage"
        style={{
          width: isSmallScreen ? "5rem" : "100px", // Fixed width
          height: isSmallScreen ? "5rem" : "100px", // Fixed height
          overflow: "hidden", // Hide overflow to maintain square shape
          borderRadius: "16px",
        }}
      >
        {userData && isCurrentUserProfile ? (
          <UpdatePFP
            Uid={user?.uid}
            userData={userData}
            avatarSize="xxl"
            className=""
            style={{
              objectFit: "cover", // Cover the entire container area
              objectPosition: "center", // Center the image within the div
            }}
            onProfilePictureUpdate={handleProfilePictureUpdate}
          />
        ) : (
          <ProfilePicture userData={userData} />
        )}
      </div>
    );
  };
  const handleCreateNewList = async () => {
    const listName = newListName.trim();
    if (newListName?.length === 0 || error || newListName[0] === " ") return;
    else if (/^\d+$/.test(newListName)) {
      setError("List name cannot be completely numeric");
      return;
    } else if (/[!@#$%^&*,.?":{}|<>\=+\;()/\\[\]]/.test(newListName)) {
      setError("List name cannot contain special characters");
      return;
    } else if (await listNameExists(user, listName)) {
      setError("List name already exists");
      return;
    }
    try {
      setLoadingButton(true);
      if (listName) {
        const capitalizedListName =
          listName.charAt(0).toUpperCase() + listName.slice(1);
        const response = await axios.post(
          `${process.env.REACT_APP_GEMINI}/getTags`,
          {
            text: capitalizedListName,
          }
        );

        const tags = response.data.result;
        const newListId = await addToSavedList(capitalizedListName, "", tags);
        if (newListId) {
          // Create a team channel for the newly created list
          await createTeamChannel(newListId, capitalizedListName, user?.uid);

          // Set the user as admin in the channel
          // await channel.addMembers([user?.uid], { text: `${user.displayName} created the list.`, role: "admin" });
        }
        toast.success(
          ` ${capitalizedListName} Shopping List has been created`,
          toastOptions
        );

        setNewListName("");
        handleCloseNewModal();
      }
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error creating New shopping list:", error.message);
    } finally {
      setLoadingButton(false);
    }
  };

  const addToSavedList = async (listName, size, tags = []) => {
    if (!user) return;

    try {
      const listDocRef = doc(db, "users", user?.uid, "shoppingList", listName);

      // Check if the list document exists
      const listDoc = await getDoc(listDocRef);
      let listId;
      if (!listDoc.exists()) {
        // If the list does not exist, create it
        listId = uuid4();
        await setDoc(listDocRef, {
          dateCreated: serverTimestamp(),
          lastUpdated: serverTimestamp(),
          listName: listName,
          listId: listId,
          visibility: "Public",
          tags: tags,
        });

        await saveShoppingListToAlgolia(user, listName);
      } else {
        // If the list already exists, use its existing listId
        listId = listDoc.data().listId;
      }

      // Update the local state
      console.log("Product added to the list successfully!");
      return listId;
    } catch (error) {
      console.error("Error adding product to the list:", error.message);
      return null;
    }
  };
  const createTeamChannel = async (listId, listName, creatorId) => {
    try {
      const channel = await client.channel("team", listId, {
        name: listName,
        image: `https://ui-avatars.com/api/?name=${listName}`,
      });

      await channel.create();
      await channel.addMembers([
        { user_id: creatorId, channel_role: "channel_moderator" },
      ]);
      console.log("Team channel created successfully:", channel.id);
      return channel;
    } catch (error) {
      console.error("Error creating team channel:", error);
      throw error;
    }
  };
  const userDetailsAndFollowButton = () => {
    return (
      <>
        <div
          className="d-flex align-items-center justify-content-end w-100"
          style={{ gap: "12px" }}
        >
          {isCurrentUserProfile && (
            <>
              <div
                style={{
                  borderRadius: "12px",
                  padding: "0px 32px",
                  height: "42px",
                  cursor: "pointer",
                }}
                className="d-flex align-items-center justify-content-center btn btn-outline-primary"
                onClick={() => setShowNewListModal(true)}
              >
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  Create New List
                </div>
              </div>
            </>
          )}

          {!isCurrentUserProfile &&
            userData &&
            (userData.privacySetting === undefined ||
              userData.privacySetting.message === true) && (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  borderRadius: "12px",
                  padding: "0rem 32px",
                  height: "42px",
                  backgroundColor: "#F4F9FF",
                  cursor: "pointer",
                }}
                data-target="chatToast"
                onClick={
                  user?.emailVerified ? handleDesktopChatClick : handleClick
                }
              >
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "18px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: "#005FDA",
                  }}
                >
                  Chat
                </div>
              </div>
            )}

          {!isCurrentUserProfile && (
            <CheckFollow
              myData={user}
              friendData={userData}
              componentName={"ProfilePage"}
            />
          )}
        </div>
      </>
    );
  };

  const tabsDiv = useRef();

  return (
    <>
      {/* Mobile View */}
      <style jsx>
        {`
          .profileLinkStyle {
            font-family: Inter;
            font-size: ${isSmallScreen ? "16px" : "18px"};
            line-height: 100%;
            text-align: center;
            display: inline-block;
            padding-bottom: 6px;
            white-space: nowrap;
          }
        `}
      </style>
      {isSmallScreen && user?.uid && uid && user?.uid !== uid && (
        <UserProfileChatMobile myUserId={user?.uid} profileUserId={uid} />
      )}
      {/* Desktop View */}
      {isChatOpen && (
        <ChatToast
          isOpen={isChatOpen}
          onClose={handleCloseChat}
          userData={userData}
          user={user}
          uid={uid}
          socket={socket}
        />
      )}

      {/* Mobile View */}
      <div className="d-md-none">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "10px 6px", paddingTop: 0 }}
        >
          <div
            className="d-flex align-items-center w-100"
            style={{ gap: "6px" }}
          >
            {userProfilePicture()}
            <div
              className="d-flex flex-column"
              style={{ gap: "6px", width: "100%" }}
            >
              <div
                className="text-truncate"
                style={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "black",
                  width: "100%",
                }}
              >
                {userData
                  ? userData.userName
                      .split(" ")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")
                  : ""}
              </div>

              <FollowerFollowingSidebar
                followers={followers}
                followings={followings}
                followerCount={followerCount}
                followingCount={followingCount}
                setFollowers={setFollowers}
                setFollowings={setFollowings}
                uid={uid}
              />
              <div
                className="text-truncate"
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "120%",
                  letterSpacing: "0%",
                  color: "#676A79",
                  width: "100%",
                }}
              >
                {userData?.userTitle?.trim()
                  ? userData.userTitle.length > 28
                    ? `${userData.userTitle.substring(0, 27)}...`
                    : userData.userTitle
                  : isCurrentUserProfile
                  ? "Add Bio here."
                  : "No Bio."}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop View */}
      <div
        className="d-none d-md-flex align-items-center w-100 px-2"
        style={{
          padding: "5px 0px",
          gap: "10px",
        }}
      >
        {/* Profile Picture */}
        {userProfilePicture()}
        {/* User Details and Buttons */}
        <div
          className="d-flex flex-column w-100"
          style={{
            gap: "12px",
          }}
        >
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#000000",
            }}
          >
            {userData
              ? userData.userName
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")
              : ""}
            {/* {isCurrentUserProfile && (
              <Link to="/settings/accountSetting">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    marginLeft: "8px",
                    marginBottom: "15px",
                    cursor: "pointer",
                  }}
                >
                  <g opacity="0.2">
                    <path
                      d="M18.4709 7.27828L7.59006 18.1591C6.61839 19.14 3.71256 19.5891 3.00673 18.9382C2.30089 18.2874 2.81421 15.3816 3.78588 14.4008L14.6667 3.51998C15.1691 3.04149 15.8388 2.77837 16.5325 2.78682C17.2262 2.79528 17.8892 3.07464 18.3798 3.56524C18.8704 4.05583 19.1498 4.7188 19.1582 5.41256C19.1667 6.10632 18.9036 6.77588 18.4251 7.27828H18.4709Z"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.25 19.25H11"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                </svg>
              </Link>
            )} */}
          </div>
          <FollowerFollowingSidebar
            followers={followers}
            followings={followings}
            followerCount={followerCount}
            followingCount={followingCount}
            setFollowers={setFollowers}
            setFollowings={setFollowings}
            uid={uid}
          />
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "18px",
              lineHeight: "120%",
              letterSpacing: "0%",
              color: "#676A79",
            }}
          >
            {userData?.userTitle?.trim()
              ? userData.userTitle
              : isCurrentUserProfile
              ? "Add Bio here."
              : "No Bio."}
          </div>
        </div>
        {userDetailsAndFollowButton()}
      </div>

      {/* Desktop */}
      <div
        className="d-none d-md-flex flex-row align-items-center stickyHeader mb-0 px-2"
        style={{
          marginTop: "20px",
          gap: "48px",
          padding: "10px 0px",
          backgroundColor: "white",
        }}
      >
        <Link
          to={`/userProfile/${uid}/shoppinglist`}
          onClick={() => setSelectedOption("shoppinglist")}
          className="profileLinkStyle m-0"
          style={{
            borderBottom:
              selectedOption === "shoppinglist"
                ? `2px solid rgb(0, 95, 218)`
                : "2px solid transparent",
            color: selectedOption === "shoppinglist" ? "#005FDA" : "#667085",
            fontWeight: selectedOption === "shoppinglist" ? 500 : 500,
          }}
        >
          Shopping List
        </Link>{" "}
        <Link
          to={`/userProfile/${uid}/favorites`}
          onClick={() => setSelectedOption("favorites")}
          className="profileLinkStyle m-0"
          style={{
            borderBottom:
              selectedOption === "favorites"
                ? `2px solid rgb(0, 95, 218)`
                : "2px solid transparent",
            color: selectedOption === "favorites" ? "#005FDA" : "#667085",
            fontWeight: selectedOption === "favorites" ? 500 : 500,
          }}
        >
          Favorites
        </Link>
        <Link
          to={`/userProfile/${uid}/postedlists`}
          onClick={() => setSelectedOption("postedlists")}
          className="profileLinkStyle m-0"
          style={{
            borderBottom: `
              2px solid ${
                selectedOption === "postedlists"
                  ? `rgb(0, 95, 218)`
                  : "transparent"
              }`,
            color: selectedOption === "postedlists" ? "#005FDA" : "#667085",
            fontWeight: selectedOption === "postedlists" ? 500 : 500,
          }}
        >
          Posts
        </Link>
        {/* {isCurrentUserProfile && (
          <Link
            to={`/userProfile/${uid}/stylePreferences`}
            onClick={() => setSelectedOption("stylePreferences")}
            className="profileLinkStyle m-0"
            style={{
              borderBottom:
                selectedOption === "stylePreferences"
                  ? `2px solid rgb(0, 95, 218)`
                  : "",
              color:
                selectedOption === "stylePreferences" ? "#005FDA" : "#667085",
              fontWeight: selectedOption === "stylePreferences" ? 500 : 400,
            }}
          >
            Style Preference
          </Link>
        )} */}
      </div>

      {/* Mobile */}
      {isCurrentUserProfile ? (
        <div
          className="d-flex flex-row align-items-center w-100 d-md-none"
          style={{ padding: "4px 6px", gap: "8px" }}
        >
          <div
            onClick={() => setIsOpen(true)}
            style={{
              borderRadius: "8px",
              width: "100%",
              height: "2rem",
              backgroundColor: "#F4F9FF",
              cursor: "pointer",
            }}
            className="d-flex align-items-center justify-content-center"
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "#005FDA",
              }}
            >
              Create New List
            </div>
          </div>
          <div
            style={{
              borderRadius: "8px",
              width: "100%",
              height: "2rem",
              backgroundColor: "#F4F4F4",
              cursor: "pointer",
            }}
            className="d-flex align-items-center justify-content-center"
            onClick={() => navigate("/settings/accountSetting")}
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "#444444",
              }}
            >
              Edit Profile
            </div>
          </div>
          <BottomTray
            text={"Create New List"}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          >
            <CreateNewList
              handleCreateNewList={handleCreateNewList}
              error={error}
              newListName={newListName}
              setError={setError}
              setNewListName={setNewListName}
              loading={loadingButton}
              isSubmitted={isSubmitted}
              setIsSubmitted={setIsSubmitted}
            />
          </BottomTray>
        </div>
      ) : (
        <div
          className="d-flex flex-row align-items-center w-100 d-md-none"
          style={{ padding: "4px 6px", gap: "8px" }}
        >
          <CheckFollow
            myData={user}
            friendData={userData}
            componentName={"ProfilePage"}
          />
          {userData &&
            (userData.privacySetting === undefined ||
              userData.privacySetting.message === true) && (
              <div
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  height: "2rem",
                  backgroundColor: "#F4F9FF",
                  cursor: "pointer",
                }}
                className="d-flex align-items-center justify-content-center"
                // data-target="chatToast"
                onClick={user?.emailVerified ? handleChatClick : handleClick}
              >
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                    color: "#005FDA",
                  }}
                >
                  Chat
                </div>
              </div>
            )}
        </div>
      )}

      <div ref={tabsDiv} className={`d-md-none stickyHeaderMobile`}>
        <div
          className="d-flex flex-row align-items-center hiddenScrollbar bg-white"
          style={{
            padding: "6.5px 6px",
            gap: "16px",
            overflowX: "auto",
          }}
        >
          <Link
            to={`/userProfile/${uid}/shoppinglist`}
            onClick={() => setSelectedOption("shoppinglist")}
            className="profileLinkStyle m-0"
            style={{
              backgroundColor:
                selectedOption === "shoppinglist" ? `#F4F9FF` : "",
              color: selectedOption === "shoppinglist" ? "#005FDA" : "black",
              padding: "4px 6px",
              fontWeight: 400,
              borderRadius: "4px",
            }}
          >
            Shopping List
          </Link>
          {isCurrentUserProfile && (
            <Link
              to={`/userProfile/${uid}/favorites`}
              onClick={() => setSelectedOption("favorites")}
              className="profileLinkStyle m-0"
              style={{
                backgroundColor:
                  selectedOption === "favorites" ? `#F4F9FF` : "",
                color: selectedOption === "favorites" ? "#005FDA" : "black",
                padding: "4px 6px",
                fontWeight: 400,
                borderRadius: "4px",
              }}
            >
              Favorites
            </Link>
          )}
          <Link
            to={`/userProfile/${uid}/postedlists`}
            onClick={() => setSelectedOption("postedlists")}
            className="profileLinkStyle m-0"
            style={{
              backgroundColor:
                selectedOption === "postedlists" ? `#F4F9FF` : "",
              color: selectedOption === "postedlists" ? "#005FDA" : "black",
              padding: "4px 6px",
              fontWeight: 400,
              borderRadius: "4px",
            }}
          >
            Posts
          </Link>
          {/* {isCurrentUserProfile && (
            <Link
              to={`/userProfile/${uid}/stylePreferences`}
              onClick={() => setSelectedOption("stylePreferences")}
              className="profileLinkStyle m-0"
              style={{
                backgroundColor:
                  selectedOption === "stylePreferences" ? `#F4F9FF` : "",
                color:
                  selectedOption === "stylePreferences" ? "#005FDA" : "black",
                padding: "4px 6px",
                fontWeight: 400,
                borderRadius: "4px",
              }}
            >
              Style Preference
            </Link>
          )} */}
        </div>
      </div>

      <Modal centered show={show} onHide={handleClose}>
        <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
          <div className="d-flex flex-column">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">Accept Friend Request</div>
              <button
                type="button"
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "22px",
                  height: "22px",
                  border: "1px solid red",
                  borderRadius: "50%",
                  color: "red",
                  fontSize: "16px",
                  fontWeight: "lighter",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  backgroundColor: "white",
                }}
                onClick={handleClose}
              >
                x
              </button>
            </div>
            <p>
              {userData &&
                userData?.userName
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}{" "}
              wants to connect with you. Once accepted, you can share shopping
              lists and collaborate easily.
            </p>
          </div>
          <div className="d-flex flex-column gap-2 w-100 mt-3">
            <Button
              className="rounded-3"
              variant="primary"
              onClick={() => handleAccept()}
            >
              Accept
            </Button>
            <Button
              className="rounded-3"
              variant="danger-soft"
              onClick={() => handleCancel()}
            >
              Decline
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showNewListModal} onHide={handleCloseNewModal} centered>
        <Modal.Body>
          <div className="d-flex flex-column mb-3">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">Create New List</div>
              <button
                type="button"
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: "25px",
                  height: "25px",
                  border: "1px solid red",
                  borderRadius: "50%",
                  color: "red",
                  fontSize: "16px",
                  fontWeight: "lighter",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  backgroundColor: "white",
                }}
                onClick={handleCloseNewModal}
              >
                x
              </button>
            </div>
            <p className="m-0">
              Enter a name for your new list, and save the product to it.
            </p>
          </div>
          <Form
            className="d-flex flex-column w-100 gap-2"
            onSubmit={(e) => {
              e.preventDefault();
              handleCreateNewList();
            }}
          >
            <div className="p-0 w-100">
              <Form.Control
                type="text"
                className="rounded-3"
                placeholder="Create new list"
                value={newListName}
                onChange={(e) => {
                  setNewListName(e.target.value);
                  setError("");
                  if (/^\d+$/.test(e.target.value)) {
                    setError("List name cannot be completely numeric");
                  } else if (
                    /[!@#$%^&*,.?":{}|<>\=+\;()/\\[\]]/.test(e.target.value)
                  ) {
                    setError("List name cannot contain special characters");
                  }
                }}
              />
            </div>
            <div className="p-0">
              <Button
                variant="primary"
                type="submit"
                className="container rounded-3"
                data-bs-dismiss="modal"
                disabled={
                  newListName?.length === 0 ||
                  newListName[0] === " " ||
                  error === true
                }
              >
                {loadingButton ? (
                  <div
                    className="spinner-border text-white"
                    style={{ width: "1rem", height: "1rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Form>
          {error && <div className="text-danger">{error}</div>}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserProfileHeader5;
